var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 148,
    viewBox: "0 0 160 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_2832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.979 13.4699H81.5516L54.8905 0H19.9875C8.94265 0 0 9.0248 0 20.1711V40.3422L160 39.534V33.6073C160 22.461 151.057 13.4362 140.013 13.4362L139.979 13.4699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 148H160V53.0039L0 53.7784V148Z",
    fill: "url(#paint0_linear_752_2832)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_2832",
    x1: 80,
    y1: 53.0039,
    x2: 80,
    y2: 161.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EEF0F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_2832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFile);
export default __webpack_public_path__ + "static/media/ico-file.c688e9cf5e54be99ed497894d2a3ac0f.svg";
export { ForwardRef as ReactComponent };